import {createBrowserRouter} from "react-router-dom";

// Dashboard
import Layout from "../layout/Layout";
import Home from "../Page/Dashboard/Home/Page/Home";

// Auth
import NotFound from "../Auth/NotFound";
import Login from "../Auth/Login";
import Error from "../Auth/Error";
import Register from "../Auth/Register";
import NewPassword from "../Auth/NewPassword";
import LockScreen from "../Auth/LockScreen";
import Verification from "../Auth/Verification";
import {routes} from "./routes";
import Report from "../Page/Dashboard/Report/Page/Report";
import ReportDetails from "../Page/Dashboard/Report/Page/ReportDetails";

// Settings
import Profile from "../Page/Settings/page/Profile/Profile";
import Configuration from "../Page/Settings/page/configuration/Configuration";
import Department from "../Page/Settings/page/configuration/page/Department/Department";
import DepartmentTypes from "../Page/Settings/page/configuration/page/DepartmentTypes/DepartmentTypes";
import PayrollType from "../Page/Settings/page/configuration/page/PayrollTypes/PayrollType";
import BloodGroup from "../Page/Settings/page/configuration/page/BloodGroups/BloodGroup";
import FuelType from "../Page/Settings/page/configuration/page/FuelTypes/FuelType";
import RequisitionTypes from "../Page/Settings/page/configuration/page/RequisitionTypes/RequisitionTypes";
import VehicleType from "../Page/Settings/page/configuration/page/VehicleTypes/VehicleType";
import VehicleBrand from "../Page/Settings/page/configuration/page/VehicleBrands/VehicleBrand";
import VehicleParkingSlotType
    from "../Page/Settings/page/configuration/page/VehicleParkingSlotTypes/VehicleParkingSlotType";
import VehicleParkingCampus
    from "../Page/Settings/page/configuration/page/VehicleParkingCompuses/page/VehicleParkingCampus";
import FuelStation from "../Page/Settings/page/configuration/page/FuelStations/FuelStation";
import DocumentTypes from "../Page/Settings/page/configuration/page/DocumentTypes/DocumentTypes";
import DesignationTypes from "../Page/Settings/page/configuration/page/DesignationTypes/DesignationTypes";
import RoleAndPermission from "../Page/Settings/page/configuration/page/RoleAndPermission/RoleAndPermission";
import ManageEmployee from "../Page/Management/Page/Administration/Page/ManageEmployee/ManageEmployee";
import ManageEmployeeById from "../Page/Management/Page/Administration/Page/ManageEmployeeById/ManageEmployeeById";
import VehicleParkingCampusesAdd
    from "../Page/Settings/page/configuration/page/VehicleParkingCompuses/page/VehicleParkingCampusesAdd";
import ManageVehicles from "../Page/Management/Page/Vehicle/Page/ManageVehicles/ManageVehicles";
import ParkingSlots from "../Page/Management/Page/Parking/Page/ParkingSlots/ParkingSlots";
import VehicleDeviceVendor from "../Page/Settings/page/configuration/page/VehicleDeviceVendor/VehicleDeviceVendor";
import VehicleTrackingDevices
    from "../Page/Settings/page/configuration/page/VehicleTrackingDevices/VehicleTrackingDevices";
import VehicleOwnership from "../Page/Management/Page/Vehicle/Page/VehicleOwnership/VehicleOwnership";
import ParkingReservation from "../Page/Management/Page/Parking/Page/ParkingReservation/ParkingReservation";
import AssignDriver from "../Page/Management/Page/Vehicle/Page/AssignDriver/AssignDriver";
import RefuelingLog from "../Page/Management/Page/ReFuel/RefuleingLog/RefuelingLog";
import DeviceMapping from "../Page/Settings/page/configuration/page/DeviceMapping/DeviceMapping";
import AddEmployee from "../Page/Management/Page/Administration/Page/AddEmployee/AddEmployee";
import UserProfile from "../Page/Profile/UserProfile/page/UserProfile";
import PickupAndDrop from "../Page/Management/Page/PickupDrop/Page/PickupAndDrop";
import VehicleRoute from "../Page/Management/Page/PickupDrop/Page/VehicleRoute";


export const router = createBrowserRouter([
    {
        path: routes.home,
        element: <Layout />,
        errorElement: <NotFound />,
        children: [
            //
            {
                index: true,
                element: <Home />,
            },

            {
                path: routes.userProfile,
                element: <UserProfile/>

            },
            // Reports
            {
                path:routes.reports,
                children:[
                    {
                        // path: routes.reports,
                        index: true,
                        element: <Report />
                    },
                    {
                        path: routes.reportById,
                        element: <ReportDetails/>
                    },

                ]
            },
            // management

            {
              path:routes.manageEmployees,
                children:[
                    {
                        index: true,
                        element:  <ManageEmployee/>
                    },
                    {
                        path: routes.manageEmployeeById,
                        element: <ManageEmployeeById/>
                    }
                ]

            },
            {
              path: routes.addEmployee,
              element: <AddEmployee/>
            },


            // vehicle management
            {
              path: routes.manageVehicles,
              element: <ManageVehicles/>
            },
            {
              path: routes.vehicleOwnership,
              element:   <VehicleOwnership/>
            },
            {
              path: routes.assignDriver,
              element: <AssignDriver/>
            },
            // fuel management
            {
              path: routes.refuelingLog,
              element: <RefuelingLog/>
            },

            // parking management
            {
                path: routes.parkingSlots,
                element: <ParkingSlots/>
            },
            {
                path: routes.parkingReservations,
                element: <ParkingReservation/>
            },

            // settings
            {
                path: routes.settingsProfile,
                element: <Profile/>
            },
            {
                path: routes.settingsConfiguration,
                element: <Configuration/>
            },
            {
                path: routes.settingsConfigureDepartment,
                element: <Department/>
            },
            {
                path: routes.settingsConfigureDepartmentTypes,
                element: <DepartmentTypes/>
            },
            {
                path: routes.settingsConfigurePayrollTypes,
                element: <PayrollType/>
            },
            {
                path: routes.settingsConfigureBloodGroups,
                element: <BloodGroup/>
            },
            {
              path: routes.settingsConfigureDocumentTypes,
                element: <DocumentTypes/>
            },
            {
              path:routes.settingsConfigureDesignationTypes,
              element: <DesignationTypes/>
            },
            {
                path: routes.settingsConfigureFuelTypes,
                element: <FuelType/>
            },
            {
              path: routes.settingsConfigureFuelStation,
              element: <FuelStation/>
            },
            {
                path: routes.settingsConfigureRequisitionTypes,
                element: <RequisitionTypes/>
            },
            {
                path: routes.settingsConfigureVehicleTypes,
                element: <VehicleType/>
            },
            {
                path: routes.settingsConfigureVehicleBrands,
                element: <VehicleBrand/>
            },
            {
              path: routes.settingsConfigureVehicleDeviceVendor,
                element: <VehicleDeviceVendor/>
            },
            {
              path: routes.settingsConfigureVehicleTrackingDevices,
              element: <VehicleTrackingDevices/>
            },
            {
                path: routes.settingsConfigureVehicleParkingSlotTypes,
                element: <VehicleParkingSlotType/>
            },
            {
                path: routes.settingsConfigureVehicleParkingCampuses,
                element: <VehicleParkingCampus/>
            },
            {
                path: routes.settingsConfigureVehicleParkingCampusesAdd,
                element: <VehicleParkingCampusesAdd/>
            },
            {
                path: routes.settingsConfigureManageRoles,
                element: <RoleAndPermission/>
            },
            {
                path: routes.settingsConfigureDeviceMapping,
                element: <DeviceMapping/>
            },
            {
                path: routes.managePickupAndDrop,
                element: <PickupAndDrop/>
            },
            {
                path: routes.manageRoute,
                element: <VehicleRoute/>
            }



        ],
    },
    {
        path: "/auth",
        children: [
            {
                path: "login",
                element: <Login />,
            },
            {
                path: "register",
                element: <Register />,
            },
            {
                path: "new-password",
                element: <NewPassword />,
            },
            {
                path: "error",
                element: <Error />,
            },
            {
                path: "lock-screen",
                element: <LockScreen />,
            },
            {
                path: "verification",
                element: <Verification />,
            },
        ],
    },

]);

